// extracted by mini-css-extract-plugin
export default {"externalLinks":"ExternalLinks_externalLinks__i4m8G","inlineLink":"ExternalLinks_inlineLink__56wuy"};